/** @return string */
export const GIT_REV = process.env.VUE_APP_GIT_REV;
/**
 * @return prod | qa | dev
 * 실행하고 있는 망에 대한 정보 입니다.
 *  */
export const ENV = process.env.VUE_APP_ENV;
/**
 * @return boolean
 *
 * 모니터링 툴(sentry)등의 활성화 여부에 대한 정보 입니다.
 *  */
export const MONITOR_ENV = process.env.VUE_APP_MONTIOR_ACTIVE;
